import React, { useState } from 'react';

import DetailIcon from '@/common/detail-icon';
import doLog from '@/common/log';

import './index.less';

interface IPropType {
  i18n: DetailTypes.i18n;
  shown: number;
  updateShown: (v: number) => void;
  elementId: string;
  logMoreName: string;
  logLessName: string;
}
export default function MoreLess(props: IPropType) {
  const { i18n, shown, updateShown, elementId, logMoreName, logLessName } = props;
  return (
    <div className={shown ? 'more-bg' : 'less-bg'}>
      <a
        href="#"
        onClick={e => {
          e.preventDefault();
          if (shown === 1) {
            doLog(logMoreName);
          } else {
            doLog(logLessName);
            const element = document.querySelector(elementId);
            if (element) {
              const elementPosition = element.getBoundingClientRect();
              const scrollY = window.scrollY;
              const elementTop = elementPosition.top;
              if (elementTop < 0) {
                // 滚动出屏幕外
                window.scrollTo({
                  top: scrollY + elementTop - 150,
                  behavior: 'smooth',
                });
              }
            }
          }
          updateShown(shown ^ 1);
        }}
      >
        {shown === 1 ? i18n['product_detail_attributes_show_more'] : i18n['pc-fantasy_show_less']}
      </a>{' '}
      <DetailIcon className="detail-symbol" symbol={shown === 1 ? 'icon-down' : 'icon-up'} />
    </div>
  );
}
